import { Menu, Layout, Divider, Typography, Button } from "antd"

//icons
import { ImInsertTemplate } from "react-icons/im"
import { MdAdminPanelSettings, MdSummarize } from "react-icons/md"

import {
  CalculatorOutlined,
  CheckCircleOutlined,
  DashboardOutlined,
  DollarOutlined,
  EuroCircleOutlined,
  FileOutlined,
  StopOutlined,
  TeamOutlined,
  UserOutlined,
  UnorderedListOutlined,
  ShoppingCartOutlined,
  BorderOuterOutlined,
  ExclamationCircleOutlined,
  RollbackOutlined,
  PrinterOutlined,
  PrinterFilled,
  DatabaseOutlined,
  DatabaseFilled,
  UserAddOutlined,
  BookOutlined,
  TrademarkCircleOutlined,
  // MergeCellsOutlined,
  FileTextOutlined,
  FileAddOutlined,
  RadiusBottomleftOutlined,
  QuestionCircleOutlined,
  NotificationOutlined,
  ClockCircleOutlined,
  ContainerOutlined,
  FileTextFilled,
  DollarCircleOutlined,
  WarningOutlined,
  ShopOutlined,
  HistoryOutlined,
  HomeOutlined,
  BankOutlined,
  InsertRowRightOutlined,
  MoneyCollectOutlined,
} from "@ant-design/icons"
import { FaRegHandPaper } from "react-icons/fa"
import { LiaShippingFastSolid } from "react-icons/lia"

import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import "../css/Sidebar.css"
import { PiFactory, PiUserList } from "react-icons/pi"

import { useAuthContext } from "../../hooks/useAuthContext"
import { useCollection } from "../../hooks/useCollection"
import adminNotifStore from "../../store/adminNotifStore"
import useSidebarTrigger from "../../store/useSidebarTrigger"
import logo from "../../media/images/craftika-cms-logo.svg"
import logoCollapsed from "../../media/images/collapsed-logo.svg"
import { GoFilter, GoGear } from "react-icons/go"

import { GiCargoCrate } from "react-icons/gi"
import useDoneOrders from "../../store/SidebarNotifs/useDoneOrders"
import { getItem, isThereBadge } from "./HelperFunctions"
import useTapeTechnicalRequests from "../../store/Designer/useTapeTechnicalRequests"
import useFetchPriceRequests from "../../store/Manager/useFetchPriceRequests"
import useAdminActiveRequests from "../../store/Admin/useAdminActiveRequests"
import { TbPigMoney, TbTicket } from "react-icons/tb"
import useAdminModeStore from "../../store/Admin/adminMode"
import useHoldOrders from "../../store/Accounting/useHoldOrders"
import usePrePaymentOrders from "../../store/SidebarNotifs/usePrePaymentOrders"
import useAwaitingDocWarehouse from "../../store/SidebarNotifs/useAwaitingDocWarehouse"
import useFetchTickets from "../../store/Tickets/useTicketsFetch"
import useFetchTicketsHoldOrders from "../../store/Tickets/useFetchTicketHoldOrders"
import { HiOutlineHandRaised } from "react-icons/hi2"

const { Text } = Typography

const { Sider } = Layout
export function Sidebar() {
  const location = useLocation()
  const navigate = useNavigate()
  const { sidebarCollapse, setSidebarCollapse } = useSidebarTrigger()
  const user = useAuthContext()
  const { adminMode, setAdminMode } = useAdminModeStore()

  const [selectedSideBar, setSelectedSidebar] = useState(null)

  //gets data for sidebar "sent back"
  const { data } = useCollection(
    "priceCalculation",
    ["user", "==", user.user.uid],
    ["sentBack", "==", true],
  )
  //data for managers to see sent back prices
  const { data: sentBackOrders, loading: sentBackOrderLoading } = useCollection(
    "orders",
    ["uid", "==", user.user.uid],
    ["orderStatus", "==", 0],
    ["orderForAdmin", "==", false],
  )

  //data for managers to see sent back prices
  const { data: sentBackOrdersAdmin, loading: sentBackOrdersAdminLoading } = useCollection(
    "orders",
    ["orderStatus", "==", 0],
    ["orderForAdmin", "==", true],
  )

  //data for orders for designers
  const { data: designerData, loading: designerLoading } = useCollection("orders", [
    "orderStatus",
    "==",
    1,
  ])
  const { data: designerTechnicalReq, loading: designerTechnicalReqLoading } = useCollection(
    "priceCalculation",
    ["hasTechincalPage", "==", 1],
  )
  //data for orders for paper Manager
  const { data: paperManagerData, loading: paperManagerLoading } = useCollection("orders", [
    "orderStatus",
    "==",
    2,
  ])

  //access to store
  const { setAdminOrders } = adminNotifStore()

  //sales orders
  const { loading: doneOrdersLoading, doneOrdersCount } = useDoneOrders((state) => state)
  const { loading: prePaymentLoading, prePaymentOrdersCount } = usePrePaymentOrders(
    (state) => state,
  )
  const { loading: awaitingDocWarehouseLoading, awaitingDocWarehouseOrdersCount } =
    useAwaitingDocWarehouse((state) => state)

  //admin
  const { activeRequestCount } = useAdminActiveRequests()

  //deisnger
  const { loading: tapeRequestLoading, technicalRequestsCount } = useTapeTechnicalRequests(
    (state) => state,
  )

  //accountant store
  const { loading: holdOrdersLoading, holdOrdersCount } = useHoldOrders((state) => state)

  //user store
  const { precRequestCount } = useFetchPriceRequests()

  //general fetches
  //tickets
  const { ticketsCount, loading: ticketsLoading } = useFetchTickets()
  const { ticketsHoldOrderCount, loading: ticketsHoldOrdersLoading } = useFetchTicketsHoldOrders()

  useEffect(() => {
    //simple divider
    const dividerItem = {
      type: "divider", // Must have
    }

    //user panel headline
    const userPanelHeader = {
      type: "group", // Must have
      label: "Menu",
    }

    //admin panel headline
    const adminPanelHeader = {
      type: "group", // Must have
      label: "Admin",
    }

    //page list for users
    const pages = [
      userPanelHeader,
      getItem("Sales Overview", "/sales-report-overview", <TbPigMoney />),
      // getItem("Dashboard", "/", <DashboardOutlined />),
      getItem("Calculation", "/calculations", <CalculatorOutlined />),
      isThereBadge(ticketsLoading ? "" : ticketsCount, "Tickets", "/tickets", <TbTicket />),

      // getItem("Tickets", "/tickets", <IoTicketOutline />),
      isThereBadge(data?.length + precRequestCount, "My Prices", "prices", <EuroCircleOutlined />, [
        getItem("Approved", "/saved-prices", <CheckCircleOutlined />),
        getItem("Unaproved", "/unapproved-prices", <StopOutlined />),
        isThereBadge(precRequestCount, "Requests", "/admin-requests", <QuestionCircleOutlined />),
        isThereBadge(data?.length, "Sent Back", "/sent-back-prices", <ExclamationCircleOutlined />),
        getItem("Templates", "/price-templates", <BorderOuterOutlined />),
        getItem("Price Filters", "/price-filters", <GoFilter />),
        getItem("Tape Products", "/tape-prices", <RadiusBottomleftOutlined />),
      ]),

      isThereBadge(
        sentBackOrderLoading ? "" : sentBackOrders?.length,
        "Orders",
        "orders",
        <ShoppingCartOutlined />,
        [
          isThereBadge(
            prePaymentLoading && awaitingDocWarehouseLoading && ticketsHoldOrdersLoading
              ? ""
              : prePaymentOrdersCount + awaitingDocWarehouseOrdersCount + ticketsHoldOrderCount,
            "My Orders",
            "/orders/all-orders",
            <ShoppingCartOutlined />,
          ),
          // getItem("Orders", "/orders/orders", <ShoppingCartOutlined />),
          // getItem("Create", "/orders/create-order", <PlusCircleOutlined />),
          isThereBadge(
            sentBackOrderLoading ? "" : sentBackOrders?.length,
            "Sent Back",
            "/orders/sent-back",
            <RollbackOutlined />,
          ),
          getItem("Complaints", "/complaints", <ExclamationCircleOutlined />),
        ],
      ),
      getItem("Clients", "/clients", <TeamOutlined />, [
        getItem("Leads", "/all-leads", <PiUserList />),
        getItem("Client List", "/clients/clients-list", <UserOutlined />),
        getItem("Create Client", "/clients/create-client", <UserAddOutlined />),
      ]),
      // getItem("Report", "/report", <TbPigMoney />),
      getItem("Materials List", "/user/user-materials", <FileOutlined />),
      getItem("Invoices", "Invoices", <FileTextOutlined />, [
        getItem("My Invoices", "/invoices/all-invoices", <FileTextOutlined />),
        getItem("My Proformas", "/invoices/all-proformas", <FileTextFilled />),
        getItem("Custom Invoice", "/invoices/create-invoice", <FileAddOutlined />),
        getItem("Packing Lists", "/invoices/all-packing-lists", <FileTextOutlined />),
        getItem("Overdue", "/invoices/overdue-payments", <WarningOutlined />),
      ]),
    ]

    //page list for admins
    const adminPages = [
      dividerItem,
      adminPanelHeader,
      getItem("Admin", "Admin Panel", <MdAdminPanelSettings />, [
        getItem("Roll History", "/admin/roll-history", <HistoryOutlined />),
        getItem("Banking", "/admin/banking", <BankOutlined />),
        getItem("Salaries", "admin/salaries", <DollarCircleOutlined />),
      ]),
      getItem("Sales", "Admin Sales", <DollarCircleOutlined />, [
        getItem("Sales Overview", "/admin/sales-report", <TbPigMoney />),
        getItem("Production Orders", "/admin/production-orders", <ShoppingCartOutlined />),
        getItem("Overdue", "/admin/overdue-payments", <WarningOutlined />),
        getItem("All Prices", "/admin/all-prices", <DollarOutlined />),
        getItem("All Clients", "/admin/all-clients", <UserOutlined />),
        getItem("All Leads", "/admin/all-leads", <PiUserList />),
        getItem("Manufacturers", "/admin/manufacturers", <PiFactory />),
        getItem("Mp Orders", "/admin/mp-orders", <HistoryOutlined />),
        getItem("Complaints", "/complaints", <ExclamationCircleOutlined />),
      ]),
      getItem("Warehouse", "Admin Materials", <BookOutlined />, [
        getItem("Raw M. Supp.", "/admin/suppliers", <GiCargoCrate />),
        getItem("Materials", "/admin/materials", <FileOutlined />),
        getItem("Rolls", "/admin/rolls", <TrademarkCircleOutlined />),
        getItem("Shop Manag.", "/admin/roll-management", <ShoppingCartOutlined />),
        getItem("Shop Order H.", "/admin/currenty-roll-orders", <HistoryOutlined />),
      ]),
      getItem("Accounting", "invoices", <DatabaseOutlined />, [
        getItem("All Invoices", "/admin/accounting-invoices", <DatabaseFilled />),
        getItem("All Proformas", "/admin/accounting-proformas", <DatabaseOutlined />),
        getItem("Client Match", "/admin/invoice-client-match", <ContainerOutlined />),
      ]),
      getItem("Notifications", "/admin/notifications", <NotificationOutlined />),
      getItem("Machine Settings", "/admin-data", <GoGear />),
      getItem("Order Costs", "/order-costs", <DollarOutlined />),
    ]

    //page list for paperManager
    const paperManagerPages = [
      getItem("Dashboard", "/", <DashboardOutlined />),
      isThereBadge(
        ticketsLoading ? "" : ticketsCount,
        "Tickets",
        "/paper-manager/tickets",
        <TbTicket />,
      ),
      getItem("Warehouse", "WarehouseMaterials", <BookOutlined />, [
        getItem("Materials", "/paper-manager/materials", <FileOutlined />),
        getItem("Rolls", "/paper-manager/rolls", <TrademarkCircleOutlined />),
        getItem("Order Roll", "/paper-manager/roll-order", <ShoppingCartOutlined />),
        getItem("Current Orders", "/paper-manager/currenty-roll-orders", <ShoppingCartOutlined />),
      ]),

      getItem("Orders", "/paper-manager/orders", <ShoppingCartOutlined />),
      getItem("Machines", "Order Managment", <PrinterOutlined />, [
        getItem("Arsoma", "/paper-manager/arsoma-orders", <PrinterFilled />),
        getItem("Viva", "/paper-manager/viva-orders", <PrinterFilled />),
        getItem("Tape", "/paper-manager/tape-orders", <PrinterFilled />),
        getItem("Cutter", "/paper-manager/cutter-orders", <PrinterFilled />),
        getItem("Winder", "/paper-manager/winder-orders", <PrinterFilled />),
      ]),
    ]

    //page list for designer
    const designerPages = [
      getItem("Dashboard", "/", <DashboardOutlined />),
      getItem("Print Plates", "plates", <CalculatorOutlined />, [
        getItem("Arsoma Plates", "/designer/arsoma-plates", <UnorderedListOutlined />),
        getItem("Viva Plates", "/designer/viva-plates", <UnorderedListOutlined />),
        getItem("Tape Plates", "/designer/tape-plates", <UnorderedListOutlined />),
      ]),
      isThereBadge(
        designerTechnicalReqLoading ? "" : designerTechnicalReq?.length,
        "Tech. Requests",
        "/designer/technical-requests",
        <QuestionCircleOutlined />,
      ),
      isThereBadge(
        tapeRequestLoading ? "" : technicalRequestsCount,
        "Tape Tech. R.",
        "/designer/tape-technical-requests",
        <QuestionCircleOutlined />,
      ),
      // isThereBadge(
      //   designerLoading ? "" : designerData?.length,
      //   "Orders",
      //   "/designer/order-list",
      //   <ShoppingCartOutlined />,
      // ),
      isThereBadge(
        designerLoading ? "" : designerData?.length,
        "Orders",
        "/designer/new-order-list",
        <ShoppingCartOutlined />,
      ),
      getItem("Files", "files", <FileOutlined />, [
        getItem("Plate Files", "/designer/plate-files", <FileTextOutlined />),
      ]),
    ]

    //blank manager pages
    const semiAdminPages = [
      ...pages,
      getItem(<Divider />),
      // getItem("Sales Overview", "/admin/sales-report", <TbPigMoney />),
      // getItem("Production Orders", "/admin/production-orders", <ShoppingCartOutlined />),
      // getItem("Overdue", "/admin/overdue-payments", <WarningOutlined />),
      // getItem("All Prices", "/admin/all-prices", <DollarOutlined />),
      getItem("All Clients", "/admin/all-clients", <UserOutlined />),
      getItem("All Leads", "/admin/all-leads", <PiUserList />),
      // getItem("Manufacturers", "/admin/manufacturers", <PiFactory />),
      // getItem("Warehouse", "semi-admin-warehouse", <HomeOutlined />, [
      //   getItem("Order Roll", "/admin/roll-order", <ShoppingCartOutlined />),
      //   getItem("Current Orders", "/admin/currenty-roll-orders", <ShoppingCartOutlined />),
      // ]),
      // getItem("Accounting", "invoices", <DatabaseOutlined />, [
      //   getItem("All Invoices", "/admin/accounting-invoices", <DatabaseFilled />),
      //   getItem("All Proformas", "/admin/accounting-proformas", <DatabaseOutlined />),
      //   getItem("Client Match", "/admin/invoice-client-match", <ContainerOutlined />),
      // ]),
    ]
    //accounting pages
    const accountantPages = [
      getItem("Invoices", "invoices", <DatabaseOutlined />, [
        getItem("All Invoices", "/accounting/accounting-invoices", <DatabaseFilled />),
        getItem("All Proformas", "/accounting/accounting-proformas", <DatabaseOutlined />),
      ]),
      getItem("Salaries", "accounting/salaries", <DollarCircleOutlined />),
      getItem("Re-Calculator", "/accounting/salary-re-calculator", <DollarCircleOutlined />),
      isThereBadge(
        ticketsLoading ? "" : ticketsCount,
        "Tickets",
        "/paper-manager/tickets",
        <TbTicket />,
      ),
      getItem("Clients", "accounting/clients", <UserOutlined />),
      isThereBadge(
        holdOrdersLoading ? "" : holdOrdersCount,
        "Hold Orders",
        "accounting/hold-orders",
        <FaRegHandPaper />,
      ),
      getItem("Roll Orders", "/accounting/roll-orders", <ShoppingCartOutlined />),
      getItem("Banking", "/accounting/banking", <BankOutlined />),
    ]
    //arsoma pages
    const arsomaPages = [
      getItem("Dashboard", "/", <DashboardOutlined />),
      getItem("Orders", "/arsoma/orders", <ShoppingCartOutlined />),
      getItem("Arsoma Plates", "/arsoma/arsoma-plates", <UnorderedListOutlined />),
      isThereBadge(ticketsLoading ? "" : ticketsCount, "Tickets", "/tickets", <TbTicket />),
    ]
    //viva pages
    const vivaPages = [
      getItem("Dashboard", "/", <DashboardOutlined />),
      getItem("Orders", "/viva/orders", <ShoppingCartOutlined />),
      getItem("Plates", "/viva/plates", <ImInsertTemplate />),
      isThereBadge(ticketsLoading ? "" : ticketsCount, "Tickets", "/tickets", <TbTicket />),
    ]
    const warehousePages = [
      getItem("Dashboard", "/", <DashboardOutlined />),
      getItem("Warehouse", "WarehouseMats", <BookOutlined />, [
        getItem("Materials", "/warehouse/materials", <FileOutlined />),
        getItem("Rolls", "/warehouse/rolls", <TrademarkCircleOutlined />),
      ]),
      getItem("Pending Orders", "/warehouse/pending-orders", <ClockCircleOutlined />),
      getItem("Warehouse Orders", "/warehouse/warehouse-orders", <ShoppingCartOutlined />),
      getItem("Roll Store", "RollStore", <ShopOutlined />, [
        getItem("Management", "/warehouse/rolls-store-management", <TrademarkCircleOutlined />),
        getItem("History", "/warehouse/roll-history", <HistoryOutlined />),
      ]),
    ]
    const winderPages = [
      getItem("Waiting List", "/winder/waiting-list", <PrinterOutlined />),
      getItem("Active Orders", "/winder/orders", <ShoppingCartOutlined />),
      getItem("Done List", "/winder/done-list", <CheckCircleOutlined />),
      isThereBadge(
        ticketsHoldOrdersLoading ? "" : ticketsHoldOrderCount,
        "Hold Orders",
        "/winder/hold-orders",
        <HiOutlineHandRaised />,
      ),
      isThereBadge(ticketsLoading ? "" : ticketsCount, "Tickets", "/winder/tickets", <TbTicket />),
    ]

    const taperPages = [
      getItem("Dashboard", "/", <DashboardOutlined />),
      getItem("Orders", "/tape/orders", <ShoppingCartOutlined />),
    ]
    const cutterPages = [
      getItem("Dashboard", "/", <DashboardOutlined />),
      getItem("Orders", "/cutter/orders", <ShoppingCartOutlined />),
    ]
    const devSpecPages = [
      getItem("Production", "Production", <RollbackOutlined />, [
        getItem("Production Orders", "/dev-spec/production-orders", <ShoppingCartOutlined />),
        getItem("All Orders", "/dev-spec/orders", <ShoppingCartOutlined />),
        getItem("Machine Settings", "/dev-spec/machine-settings", <GoGear />),
        getItem("Employee's", "/dev-spec/employee-managment", <UserOutlined />),
        getItem("Reprints", "/dev-spec/reprints", <RollbackOutlined />),
      ]),
      getItem("Accounting", "Dev Acc", <DollarCircleOutlined />, [
        getItem("All Invoices", "/dev-spec/all-invoices", <DatabaseFilled />),
        getItem("All Proformas", "/dev-spec/all-proformas", <DatabaseOutlined />),
        getItem("Overdue", "/dev-spec/overdue-payments", <WarningOutlined />),
      ]),
      getItem("Sales", "Dev Sales", <UserOutlined />, [
        getItem("All Prices", "/dev-spec/all-prices", <DollarOutlined />),
        getItem("All Clients", "/dev-spec/all-clients", <UserOutlined />),
        getItem("All Leads", "/dev-spec/all-leads", <PiUserList />),
        getItem("Calculation", "/dev-spec/calculations", <CalculatorOutlined />),
        getItem("Sales Overview", "/dev-spec/sales-report", <TbPigMoney />),
        getItem("Complaints", "/complaints", <ExclamationCircleOutlined />),
      ]),
      getItem("Warehouse", "Devspec Materials", <HomeOutlined />, [
        getItem("Warehouse", "/dev-spec/warehouse", <HomeOutlined />),
        getItem("Product Types", "/dev-spec/product-types", <InsertRowRightOutlined />),
        getItem("Supplier List", "/dev-spec/supplier-list", <LiaShippingFastSolid />),
        getItem("Raw M. Supp.", "/dev-spec/suppliers", <GiCargoCrate />),
        getItem("Materials", "/dev-spec/materials", <FileOutlined />),
        getItem("Rolls", "/dev-spec/rolls", <TrademarkCircleOutlined />),
        getItem("Shop Manag.", "/dev-spec/roll-management", <ShoppingCartOutlined />),
        getItem("Order Roll", "/dev-spec/roll-order", <ShoppingCartOutlined />),
        getItem("Shop Order H.", "/dev-spec/currenty-roll-orders", <HistoryOutlined />),
        getItem("Roll History", "/dev-spec/roll-history", <HistoryOutlined />),
      ]),
      getItem("Paper Manager", "DevSpec Paper Manager", <PrinterOutlined />, [
        getItem("Orders", "/dev-spec/paper-manager-orders", <ShoppingCartOutlined />),
        getItem("Machines", "DevSpec Machines", <PrinterOutlined />, [
          getItem("Arsoma", "/dev-spec/arsoma-orders", <PrinterFilled />),
          getItem("Viva", "/dev-spec/viva-orders", <PrinterFilled />),
          getItem("Winder", "/dev-spec/winder-orders", <PrinterFilled />),
          getItem("Tape", "/dev-spec/tape-orders", <PrinterFilled />),
        ]),
      ]),
      getItem("Banking", "/dev-spec/banking", <BankOutlined />),
      getItem("Order Costs", "/dev-spec/order-costs", <DollarOutlined />),
      getItem("Calculation", "/dev-spec/dev-calculations", <CalculatorOutlined />),
    ]

    switch (true) {
      case user.admin:
        if (adminMode) {
          setSelectedSidebar(adminPages)
        } else {
          setSelectedSidebar(pages)
        }
        break
      case user.paperManager:
        setSelectedSidebar(paperManagerPages)
        break
      case user.designer:
        setSelectedSidebar(designerPages)
        break
      case user.semiAdmin:
        setSelectedSidebar(semiAdminPages)
        break
      case user.accountant:
        setSelectedSidebar(accountantPages)
        break
      case user.arsomaUser:
        setSelectedSidebar(arsomaPages)
        break
      case user.vivaUser:
        setSelectedSidebar(vivaPages)
        break
      case user.warehouse:
        setSelectedSidebar(warehousePages)
        break
      case user.winder:
        setSelectedSidebar(winderPages)
        break
      case user.tapeUser:
        setSelectedSidebar(taperPages)
        break
      case user.cutter:
        setSelectedSidebar(cutterPages)
        break
      case user.devSpecialist:
        setSelectedSidebar(devSpecPages)
        break
      default:
        setSelectedSidebar(pages)
    }

    // Set adminOrders state in the store
    setAdminOrders(sentBackOrdersAdmin)
  }, [
    user,
    data,
    designerData,
    designerLoading,
    sentBackOrderLoading,
    sentBackOrders,
    paperManagerData,
    paperManagerLoading,
    sentBackOrdersAdmin,
    sentBackOrdersAdminLoading,
    setAdminOrders,
    designerTechnicalReq,
    doneOrdersCount,
    doneOrdersLoading,
    designerTechnicalReqLoading,
    technicalRequestsCount,
    tapeRequestLoading,
    precRequestCount,
    activeRequestCount,
    adminMode,
    holdOrdersLoading,
    holdOrdersCount,
    awaitingDocWarehouseLoading,
    awaitingDocWarehouseOrdersCount,
    prePaymentOrdersCount,
    prePaymentLoading,
    ticketsCount,
    ticketsLoading,
    ticketsHoldOrderCount,
    ticketsHoldOrdersLoading,
  ])

  //const admin mode or user mode
  const adminOrUserMode = () => {
    if (user.admin) {
      if (adminMode) {
        return (
          <Button
            style={{ background: "#1677ff", color: "white" }}
            block
            onClick={() => setAdminMode(false)}>
            SWITCH TO USER
          </Button>
        )
      } else {
        return (
          <Button
            block
            style={{ background: "#f5222d", color: "white" }}
            onClick={() => setAdminMode(true)}>
            SWITCH TO ADMIN
          </Button>
        )
      }
    }
  }

  //current user display
  const adminDisplay = () => {
    if (user.admin) {
      return (
        <div style={{ padding: 15, textAlign: "center" }}>
          <Text>Currently : {adminMode ? "Admin" : "User"}</Text>
          {adminOrUserMode()}
        </div>
      )
    }
  }

  return (
    <Sider
      theme="light"
      trigger={null}
      id="sider-container"
      collapsible
      collapsed={sidebarCollapse}
      onCollapse={(value) => setSidebarCollapse(value)}>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <svg
          style={{
            width: sidebarCollapse ? "80px" : "200px",
            height: "65px",
            transition: "width 0.3s ease, opacity 0.3s ease",
          }}>
          <image
            style={{ transition: "width 0.3s ease" }}
            href={sidebarCollapse ? logoCollapsed : logo}
            width={sidebarCollapse ? 80 : 200}
            height={65}
          />
        </svg>
      </div>
      <Divider />
      {adminDisplay()}
      <Menu
        className="menu"
        onClick={({ key }) => {
          navigate(key)
        }}
        overflowedIndicator
        theme="light"
        defaultSelectedKeys={["1"]}
        selectedKeys={[location.pathname]} // Add this line
        mode="inline"
        items={selectedSideBar}
      />
    </Sider>
  )
}
